import React from 'react';
import { reduce } from 'lodash';

const withErrorValidateByFly = validate => WrappedComponent =>
    (class Validate extends React.Component {
        static updateErrorsState = (name, nextValue, data, errors) => {
            if (Object.keys(errors).length > 0) {
                const processedData = this.getProcessedData(data, name, nextValue);
                return validate(processedData);
            }
            return errors;
        };

        static getProcessedData = (data, name, newValue) =>
            reduce(
                data,
                (result, value, key) => {
                    if (key === name) value = newValue;
                    result[key] = typeof value === 'string' ? value.trim() : value;
                    return result;
                },
                {}
            );

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    updateErrorsState={Validate.updateErrorsState}
                    getProcessedData={Validate.getProcessedData}
                />
            );
        }
    });

export default withErrorValidateByFly;
